import { Button } from '@ludolio/shared-ui';
import { useAuthStore } from '@/stores/authStore';
import { FullPageMessage } from './FullPageMessage';

export function LabsUnavailable({ message }: { message?: string }) {
  const logout = useAuthStore((state) => state.logout);
  return (
    <FullPageMessage title={message ?? 'Labs is not available'}>
      <p className="text-sm text-muted-foreground">
        Your university has not turned on Ludolio Labs for this account.
      </p>
      <Button variant="outline" onClick={() => void logout()}>Use a different account</Button>
    </FullPageMessage>
  );
}
